import { membersApi } from '../api/membersApi'

export const deleteMember = async (memberId: string) => {
  try {
    const { data } = await membersApi.deleteMember(memberId)
    return data
  } catch (error) {
    console.error(`Error deleting member: `, error)
    throw error
  }
}
